/** Public marketing site. Never use the API host here. */
export const SITE_URL = (process.env.REACT_APP_SITE_URL || 'https://innovher.com').replace(/\/$/, '');

/** Absolute URL for a site path (e.g. "/about" → "https://innovher.com/about"). */
export function siteUrl(path = '/') {
  if (!path || path === '/') return `${SITE_URL}/`;
  const clean = path.startsWith('/') ? path : `/${path}`;
  return `${SITE_URL}${clean}`;
}

export const DEFAULT_OG_IMAGE = `${SITE_URL}/innovher.webp`;

/** Shared meta copy aligned to the current InnovHer website. */
export const SITE_META = {
  brand: 'InnovHer',
  defaultTitle: 'Startup Accelerators | Business Growth & Startup Mentorship',
  defaultDescription:
    'Discover startup accelerators offering expert mentorship, business growth consulting, and proven strategies to help your startup succeed.',
  defaultKeywords:
    'InnovHer, venture builder India, where ambition becomes enterprise, InnovACE, InnovVentures, InnovIdea, InnovVeda, Studio-I, InnovPulse, InnovZ, iSSi, startup ecosystem Jaipur, Rajasthan',
  organizationDescription:
    'A venture-building platform bringing together strategy, technology, capital, capability and connections to transform possibilities into enterprises of consequence.',
};

export function formatSeoTitle(title) {
  if (!title) return SITE_META.defaultTitle;
  const trimmed = String(title).trim();
  if (/innovher/i.test(trimmed)) return trimmed;
  return `${trimmed} | InnovHer`;
}
